export const isPrimitive = (value: any) =>
  ['string', 'number', 'bigint', 'boolean', 'undefined', 'symbol'].includes(typeof value) ||
  value === null;

export const isArray = (value: any): value is any[] => Array.isArray(value);

export const isFunction = (value: any): value is Function => typeof value === 'function';

export const isObject = (value: any): value is object => !isPrimitive(value);

export const isConstructable = (() => {
  const handler = {
    construct() {
      return handler;
    },
  };

  return (value: any): any => {
    try {
      return !!new new Proxy(value, handler)();
    } catch (e) {
      return false;
    }
  };
})();
